import { Component, OnInit, ViewChild, Pipe } from "@angular/core";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  FormArray,
  UntypedFormBuilder,
} from "@angular/forms";
import { DaoService } from "./../../services/dao.service";
import { Router } from "@angular/router";
import { DataSource } from "@angular/cdk/table";

import { LstorageService } from "./../../services/lstorage.service";
import * as jwtDecode from "jwt-decode";
import { ApiResponseMappingListComponent } from "../api-response-mapping-list/api-response-mapping-list.component";
import { SpinnerService } from "src/app/shared/spinner/spinner.service";
import { SpinnerComponent } from "src/app/shared/spinner/spinner.component";
import { ToastService } from "src/app/services/toast.service";
import { decryptData, encryptData } from "src/app/services/aes.service";

@Component({
  selector: "app-api-response-mapping",
  templateUrl: "./api-response-mapping.component.html",
  styleUrls: ["./api-response-mapping.component.scss"],
})
export class ApiResponseMappingComponent implements OnInit {
  Attribute: any;
  apiResponseData: any;
  apiDynamicAttribue: any;
  apiData: any;
  entity: any;
  mappingId: any;

  groupId: any;
  parentId: any;
  apiId: any;
  sourceName: any;
  info: any;
  CSCInfo: any;
  mappingAttribute: any;
  gropId: string;
  parentAttribute: any;
  sinputAttribute: any;
  requiredAttributes: any;
  apiResponseMapping = new FormGroup({
    ApiId: new FormControl(),
    ApiResponseMappingId: new FormControl(),
    Entity: new FormControl(),
    Name: new FormControl(),
    BaseValue: new FormControl(),
    infoHighlight: new FormControl(),
    Mapping: new FormControl(),
    isActive: new FormControl(),
    createdBy: new FormControl(),
    createdOn: new FormControl(),
    modifiedBy: new FormControl(),
    modifiedOn: new FormControl(),
  });

  constructor(
    private daoService: DaoService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private token: LstorageService,
    private mappingList: ApiResponseMappingListComponent,
    private spinner: SpinnerService,
    private toast: ToastService
  ) {
    this.spinner.show();
    this.apiResponseData = this.token.getApiResponse();
    this.apiDynamicAttribue = this.token.getApiDyanamicAttribute();
    this.apiDynamicAttribue = this.apiDynamicAttribue.sort();

    this.apiData = this.token.getApiData();

    // this.daoService.getEntity().subscribe((data) => {
    //   this.entity = data;
    //   this.spinner.hide();
    // });
    // this.daoService.getEntities().subscribe((data) => {
    //   this.entity = data;
    //   this.spinner.hide();
    // });
    this.daoService.getEntities().subscribe((data) => {
      this.spinner.hide();
      var dcrptdData = JSON.parse(decryptData(data.key));
      this.daoService.defaultEntityList(dcrptdData);
      this.daoService.finalEntityList.subscribe(
        (entityList) => (this.entity = entityList)
      );
      console.log("EntityName", dcrptdData);
      // this.spinner.hide();
    });
    this.mappingId = this.token.getResponseMappingId();
    //Edit Apiresponse
    var mapId = {
      GroupId: this.mappingId,
    };
    if (this.mappingId) {
      //  this.spinner.show();
      this.daoService
        .getResponseMappingById(encryptData(JSON.stringify(mapId)))
        .subscribe((data: any) => {
          var dcrptdData = JSON.parse(decryptData(data.key));
          let mappingAttributes = JSON.parse(dcrptdData.mappingAttributes);
          console.log("dcrptdData", dcrptdData);
          // this.mappingAttribute = data.mappingAttributes;

          this.mappingAttribute = mappingAttributes;

          var dynamicMapping = this.formBuilder.array([]);

          console.log("Api Mapping response");
          console.log(data);

          // for (var i = 0; i < data.mappingAttributes.length; i++) {
          //   dynamicMapping.push(
          //     this.bindParameter(
          //       data.mappingAttributes[i].attribute,
          //       data.mappingAttributes[i].attributeMap,
          //       data.mappingAttributes[i].parameterType
          //     )
          //   );
          // }
          for (var i = 0; i < mappingAttributes.length; i++) {
            dynamicMapping.push(
              this.bindParameter(
                mappingAttributes[i].Attribute,
                mappingAttributes[i].AttributeMap,
                mappingAttributes[i].parameterType
              )
            );
          }
          var enty = {
            GroupId: dcrptdData.entity,
          };
          this.daoService
            .getAttributeByEntity(encryptData(JSON.stringify(enty)))
            .subscribe((adata: any) => {
              var dcrptdData = JSON.parse(decryptData(adata.key));
              this.Attribute = dcrptdData;
              this.EditMappingInfo();
            });

          //alert(data.name);
          // this.apiResponseMapping = data;
          this.apiResponseMapping = this.formBuilder.group({
            ApiId: [""],
            ApiResponseMappingId: [dcrptdData.apiMappingId],
            Entity: [dcrptdData.entity, [Validators.required]],
            Name: [dcrptdData.name, [Validators.required]],
            BaseValue: [dcrptdData.baseValue],
            infoHighlight: [this.info],
            Mapping: dynamicMapping,
            isActive: ["true"],
            createdBy: [""],
            createdOn: ["2020-01-03T15:50:10.213Z"],
            modifiedBy: [""],
            modifiedOn: ["2020-01-03T15:50:10.213Z"],
          });
          this.spinner.hide();
        });
    }
  }

  ngOnInit() {
    this.gropId = this.token.getGroupId();
    this.CSCInfo = this.token.getInfoHighlights();
    this.info = this.CSCInfo;
    this.apiResponseMapping = this.formBuilder.group({
      ApiId: [""],
      ApiResponseMappingId: [],
      Entity: ["", Validators.required],
      Name: ["", Validators.required],
      BaseValue: ["", Validators.required],
      infoHighlight: [this.info],
      Mapping: this.formBuilder.array([this.getParameter()]),
    });
  }

  EditMappingInfo() {
    //Bind info highlights
    var selectedInfo = "";
    this.mappingAttribute.forEach((element) => {
      var sAttribute = this.Attribute.find(
        (x) => x.attributeId === element.attributeId
      );
      // if (sAttribute.isShowInfo) {
      //   selectedInfo = selectedInfo + ">>" + sAttribute.name;
      // }
    });
    this.info = this.CSCInfo + selectedInfo;
    //
  }

  Entitychange(entity) {
    var data1 = {
      GroupId: entity,
    };
    this.daoService
      .getAttributeByEntity(encryptData(JSON.stringify(data1)))
      .subscribe((data: any) => {
        //for clear mapping data
        let atrr = JSON.parse(decryptData(data.key));
        this.clearAllParameter();
        this.Attribute = atrr;

        console.log("this.Attribute", this.Attribute);
      });
    // this.daoService
    //   .getAttributeByEntity(encryptData(JSON.stringify(data1)))
    //   .subscribe((data: any) => {
    //     let atrr = JSON.parse(decryptData(data.key));
    //     if (this.parentAttribute) {
    //       var selectedAttribute = [];
    //       atrr.forEach(function (value) {
    //         value.name = "input." + value.name;
    //         selectedAttribute.push(value);
    //       });
    //       var frequiredAttribute =
    //         this.parentAttribute.concat(selectedAttribute);
    //       console.log(atrr);
    //       console.log(frequiredAttribute);
    //       this.requiredAttributes = frequiredAttribute;
    //       this.sinputAttribute = this.requiredAttributes;
    //       this.Attribute = this.requiredAttributes;
    //     } else {
    //       var selectedAttribute = [];
    //       atrr.forEach(function (value) {
    //         value.name = "input." + value.name;
    //         selectedAttribute.push(value);
    //       });
    //       this.requiredAttributes = selectedAttribute;
    //       this.sinputAttribute = this.requiredAttributes;
    //       this.Attribute = this.requiredAttributes;
    //     }
    //   });
  }

  attributeChange(attribute) {
    var selectedInfo = "";
    this.info = "";
    // const control = <FormArray>this.apiResponseMapping.controls["Mapping"];
    const control = this.apiResponseMapping.get("Mapping") as FormArray;

    console.log("attrinute");
    console.log(attribute);

    console.log("value");
    console.log(control.value);
    control.value.forEach((element) => {
      var selectedAttribute = this.Attribute.find(
        (x) => x.attributeId === element.Attribute
      );
      if (selectedAttribute.isShowInfo) {
        selectedInfo = selectedInfo + ">>" + selectedAttribute.name;
      }
    });
    this.info = this.CSCInfo + selectedInfo;
    // For find dublicate key
  }

  //Add Response Mapping
  addResponseMapping() {
    //this.spinner.show();

    var aid = this.token.getApiId();
    var apiResultId = this.token.getApiResultId();
    var gropId = this.token.getGroupId();
    this.apiData.ApiId = aid;
    var apiManagerMapping = {
      apiManager: this.apiData,
      apiManagerMapping: {
        apiMappingId: this.mappingId,
        apiId: aid,
        Entity: this.apiResponseMapping.value.Entity,
        Name: this.apiResponseMapping.value.Name,
        BaseValue: this.apiResponseMapping.value.BaseValue,
        infoHighlight: this.info,
        mappingAttributes: this.apiResponseMapping.value.Mapping,
        isActive: true,
        createdBy: this.daoService.loggedUser.UserUniqueId,
        createdOn: "2019-09-25T06:39:20.849Z",
        modifiedBy: this.daoService.loggedUser.UserUniqueId,
        modifiedOn: "2019-09-25T06:39:20.849Z",
      },

      resultId: apiResultId,
      GroupId: gropId,
    };
    //console.log("apiManagerMapping", apiManagerMapping);
    //Find response mapping has duplicate
    let ids = {};
    let dups = [];
    this.apiResponseMapping.value.Mapping.forEach((val) => {
      if (ids[val.Attribute.attributeId]) {
        // we have already found this same id
        dups.push(val);
      } else {
        ids[val.Attribute] = true;
      }
    });
    //
    if (dups.length > 0) {
      this.spinner.hide();
      this.toast.openSnackBar(
        "Dublicate key found.Please resolve befor submit",
        "close"
      );
    } else {
      this.daoService
        .apiManagerMapping(encryptData(JSON.stringify(apiManagerMapping)))
        .subscribe((data: any) => {
          let data2 = JSON.parse(decryptData(data.data));
          console.log("Api manager data");
          console.log("data2", data2);

          if (data.isSuccess) {
            this.spinner.hide();
            this.toast.openSnackBar("Response mapped successfully", "close");
            this.groupId = this.token.getGroupId();
            this.parentId = this.token.getParentId();
            this.sourceName = data2.ApiManagerData.SourceName;
            this.apiId = data2.ApiManagerData.ApiId;
            // this.apiId = data.data.ApiManagerData.api;
            // this.token.saveApiId(this.apiId);

            this.token.saveApiId(this.apiId);

            var apigroup = {
              GroupId: this.groupId,
              SourceName: this.sourceName,
              ApiId: this.apiId,
              ParentID: this.parentId,
              IsActive: true,
              CreatedBy: this.daoService.loggedUser.UserUniqueId,
              createdOn: "2020-01-21T11:35:46.062Z",
              ModifiedBy: this.daoService.loggedUser.UserUniqueId,
              modifiedOn: "2020-01-21T11:35:46.062Z",
            };
            console.log("Api Group");
            console.log(apigroup);

            this.daoService
              .saveApiGroup(encryptData(JSON.stringify(apigroup)))
              .subscribe((datas: any) => {
                console.log("Apigroup data");
                console.log(datas);
                let data3 = JSON.parse(decryptData(data.data));

                console.log("data3", data3);
                this.token.saveGroupId(data3.groupId);
                this.spinner.hide();
              });
            this.router.navigate(["/responseMapping"]);
          }
        });
    }
  }
  //

  //Dynamic Mapping Begin
  private getParameter() {
    return this.formBuilder.group({
      Attribute: [""],
      parameterType: [""],
      AttributeMap: [""],
    });
  }

  private bindParameter(Attribute, AttributeMap, isPositional) {
    return this.formBuilder.group({
      Attribute: [Attribute],
      AttributeMap: [AttributeMap],
      parameterType: [isPositional],
    });
  }

  addParameter() {
    // const control = <FormArray>this.apiResponseMapping.controls["Mapping"];
    const control = this.apiResponseMapping.get("Mapping") as FormArray;

    control.push(this.getParameter());
  }

  removeParameter(i: number) {
    //const control = <FormArray>this.apiResponseMapping.controls["Mapping"];
    const control = this.apiResponseMapping.get("Mapping") as FormArray;
    control.removeAt(i);
    if (i == 0) {
      control.push(this.getParameter());
    }
  }

  clearAllParameter() {
    //const control = <FormArray>this.apiResponseMapping.controls["Mapping"];
    const control = this.apiResponseMapping.get("Mapping") as FormArray;
    while (control.length) {
      control.removeAt(control.length - 1);
    }
    control.clearValidators();
    control.push(this.getParameter());
  }

  handleInput(event) {
    if (event.which === 32 && !this.apiResponseMapping.value.Name.length)
      event.preventDefault();
  }

  checkDublicatevalue() {}
}
